import { createFileRoute, redirect } from "@tanstack/react-router";

import { startSection } from "@/shared/auth/access";

/** The plain address leads to the screen the person's role starts on. */
export const Route = createFileRoute("/_app/")({
  beforeLoad: ({ context }) => {
    throw redirect({ to: `/${startSection(context.role)}` });
  },
});
